<template>
  <div @mouseleave="closeoptions">
    <!-- display the date if necessary -->
    <div v-if="active && displayDateHeader" class="text-caption separator mt-2 mb-1">
      <div class="date mb-1">
        {{ simplifyDate(message.date, "LL") }}
      </div>
    </div>
    <!-- Displaying CustomPopup is used for tags -->
    <div v-if="showCustomPopup" :style="{
          display: 'flex',
          justifyContent: (message.comm_direction === 'inbound' || message.comm_direction === 'incoming' || message.comm_direction ==='received')? 'flex-start' : 'flex-end',
          position: 'relative',
        }">
      <CustomPopup v-model="showCustomPopup" :isTagpopup="isTagPopup" :tags="filteredTags" @applyTag="applyTag"
        :enableEdit="true" />
    </div>
     <!-- Display Message options -->
     <div v-if="showOptions && !showCustomPopup && active" :style="{
          display: 'flex',
          justifyContent: (message.comm_direction === 'inbound' || message.comm_direction === 'incoming' || message.comm_direction ==='received')? 'flex-start' : 'flex-end',
          position: 'relative',
        }"
      >
        <div style="display: inline;" v-if="!isUser">
          <v-icon size="17" color="primary" @click="createInternalConvo">mdi-plus</v-icon>
          <v-tooltip activator="parent" location="top">Create new convo on this item</v-tooltip>
        </div>

        <div>
          <v-icon v-if="can_manual_tagging" style="margin-left: 5px" color="red" size="17" @click="openTagPopup">mdi-tag-plus </v-icon>
          <v-tooltip activator="parent" location="top">Apply Tag</v-tooltip>
        </div>

        <div v-if="!isUser">
          <v-menu v-model="quickReminderMenuOpen" :close-on-content-click="false" location="bottom">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" style="margin-left: 5px" color="#F94C10" size="17">mdi-clock-fast</v-icon>
              <v-tooltip activator="parent" location="top">Quick Reminder</v-tooltip>
            </template>
            <v-card>
              <QuickReminderMenu @select="applyQuickReminder" />
            </v-card>
          </v-menu>
      </div>
    </div>
    <!-- display the message -->
    <div :class="'chat-bubble-container ' + (active && displayDateHeader ? 'mb-2' : '')">
      <!-- If the message data is from Calls, it will have contact_id -->
      <template v-if="!message.is_system_message">
        <v-menu :attach="'#bubble-' + message.comm_participant_id" :disabled="/^\d{10}$/.test(contact.full_name)"
          open-on-hover :close-on-content-click="false" max-width=40 min-width=20 max-height=25 location="top"
          close-delay=300 open-delay=300 z-index=3000>
          <template v-slot:activator="{ props }">
            <!--
              inbound -- incoming-call
              outbound -- outgoing-call
              incoming -- incoming-message (sms & mms)
              outgoing -- outgoing-message (sms & mms) 
              -->
            <div v-bind="props" v-bind:id="'bubble-' + message.comm_participant_id" :class="
                'chat-bubble ' +
                (message.comm_direction === 'inbound'
                  ? 'inbound'
                  : message.comm_direction === 'outbound'
                  ? 'outbound'
                  : message.comm_direction === 'incoming'
                  ? 'inbound message-incoming'
                  : message.comm_direction==='received'
                  ? 'inbound email-incoming'
                  :message.comm_direction==='sent'
                  ? 'outbound'
                  : message.comm_direction === 'outgoing' ||
                    message.comm_direction == 'delivered' ||
                    message.comm_direction == 'queued'
                  ? 'outbound'
                  : 'other-call')" 
                  :style="{maxWidth : fullWidth ? '100%' : '60%',}"
                  v-touch="{start: onTouchStart,end: onTouchEnd}" @click="showOptions = !showOptions">
              <div class="icon-spacing">
                <!-- Call missed status -->
                <div v-if="message.call_missed === 1" style="display: flex; align-items: center; gap: 4px;">
                  <v-icon v-if="getPhoneIcon(message.phone_num, contact)" size="20" color="black">mdi-{{ getPhoneIcon(message.phone_num, contact) }}</v-icon>
                  <v-icon size="20" color="red">mdi-call-missed</v-icon>
                  <span v-if="message.comm_ref">
                    <AudioPlayer :src="recording(message.call_uuid)" :class="message.comm_direction === 'inbound' ? 'inbound' : 'outbound'"></AudioPlayer>
                  </span>
                  <span v-else style="color: red; font-size: 13px;">missed call</span>
                </div>
                <div v-else-if="message.call_missed === 2" style="display: flex; align-items: center; gap: 4px; color: green;">
                  <v-icon v-if="getPhoneIcon(message.phone_num, contact)" size="20" color="green">mdi-{{ getPhoneIcon(message.phone_num, contact) }}</v-icon>
                  <v-icon size="20" color="green">mdi-phone</v-icon>
                  Call is ringing....
                </div>
                <div v-else-if="message.call_missed === 3" style="display: flex; align-items: center; gap: 4px; color: green;">
                  <v-icon v-if="getPhoneIcon(message.phone_num, contact)" size="20" color="green">mdi-{{ getPhoneIcon(message.phone_num, contact) }}</v-icon>
                  <v-icon size="20" color="green">mdi-phone</v-icon>
                  On going call
                </div>

                <!-- Text/Email messages -->
                <div v-else-if="message.text_message_id || message.email_id" :ref="setChatRefs">
                  <v-btn v-bind="props" fab v-if="
                        message.comm_direction == 'failed' ||
                        message.comm_direction === 'undelivered' ||
                        message.comm_direction === 'rejected'
                      " size="x-small" @click="resendMessage(message.text_message_id)">
                    <v-icon color="red">mdi-refresh</v-icon>
                  </v-btn>
                  <div v-if="message.users" class="user">
                    {{ getUserNames([message.users]) }}
                  </div>
                  <div v-else-if="message.email_id" class="user">
                    {{ "" }}
                  </div>
                  <div v-else class="user">
                    {{ phoneFormatTitle(contact.full_name) }}
                  </div>
                  <v-icon size="20" v-if="message.email_id">mdi-email</v-icon>
                  <v-icon v-else size="20">mdi-{{ getPhoneIcon(message.phone_num, contact) }}</v-icon>
                  <span v-if="message.email_id">
                    <b>{{ message.subject }}</b>
                    <br />
                  </span>
                    <span :ref="`text_message_${message.text_message_id}`">
                    {{
                      message.text_message_id
                      ? message.message
                      : message.email_id
                      ? message.snippet
                      : ''
                    }}
                    </span>
                  <v-tooltip v-if="message.email_id" location="bottom" text="Open More">
                    <template v-slot:activator="{ props }">
                      <v-btn @click="openModal(message.threadId)" v-bind="props" icon variant="text" size="small">
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>

                <!-- Thread messages -->
                <div v-else-if="message.threadId">
                  <div v-if="message.users" class="user">
                    {{getUserNames([message.users]) }}
                  </div>
                  <div>
                    <b>{{ message.subject }}</b>
                  </div>
                  <br />
                  <span>
                    {{message.snippet}}
                  </span>
                </div>
                <div v-else>
                  <div style="display: flex">
                    <div class="contact">
                      {{ phoneFormatTitle(contact.full_name) }}
                    </div>
                    <div v-if="message.users" class="user">
                      {{ getUserNames([message.users]) }}
                      <v-icon v-if="message.users.length > 1" small @click="alert(getUserNames(message.users))"
                        color="grey darken-2">mdi-information</v-icon>
                    </div>
                  </div>
                  <div style="display: flex; align-items: center; gap: 4px;">
                    <v-icon size="20" color="black">mdi-{{ getPhoneIcon(message.phone_num, contact) }}</v-icon>
                    <v-icon size="20" :color="message.comm_direction === 'inbound' ? 'primary' : 'grey'">
                      {{ message.comm_direction === 'inbound' ? 'mdi-phone-incoming' : 'mdi-phone-outgoing' }}
                    </v-icon>
                    <span v-if="message.comm_ref">
                      <AudioPlayer :src="recording(message.call_uuid)"></AudioPlayer>
                    </span>
                  </div>
                </div> 

                <!-- Media attachments -->
                <div v-if="message.count > 0">
                  <div v-for="(value, index) in message.media" :key="index" class="d-flex align-start" style="gap: 8px; margin-bottom: 6px;">
                    <div style="flex-shrink: 0">
                      <v-icon v-if="value.media_type == 'application/pdf'" size="40" color="red">
                        mdi-file-pdf-box
                      </v-icon>
                      <a v-if="value.media_type == 'application/pdf' " v-bind:href="getFileUrl(message,value)"
                        target="_blank">{{ value.media_url.split("/")[3].substring(15) }}</a>

                      <v-img v-on:click="openImg(getFileUrl(message,value))"
                        v-if="value.media_type != 'application/pdf'" height="150" max-height="150" max-width="250" width="250"
                        :src="getFileUrl(message,value)"></v-img>
                      <video :src="getFileUrl(message,value)" controls v-if="value.media_type == 'video/mp4'"
                        class="video-element"></video>
                    </div>

                    <div
                      v-if="value.classified_type"
                      class="d-flex align-center"
                      style="gap: 4px; font-size: 11px; cursor: pointer"
                      @click.stop="openExtractionDialog(value)"
                    >
                      <template v-if="value.upload_status === 'uploaded'">
                        <v-icon size="14" color="green">mdi-check-circle-outline</v-icon>
                        <span>Uploaded</span>
                      </template>
                      <template v-else-if="value.upload_status === 'failed'">
                        <v-icon size="14" color="error">mdi-alert-circle-outline</v-icon>
                        <span>Upload failed — review</span>
                      </template>
                      <template v-else>
                        <v-icon size="14" color="primary">mdi-text-box-search-outline</v-icon>
                        <span>Review and upload to OD</span>
                      </template>
                    </div>
                  </div>
                  </div>
                  <!-- Tags and timestamp -->
                  <div style="display: flex; align-items: center; justify-content: space-between; margin: 0.1em;">
                    <div v-if="active" style="display: inline-flex; gap: 0.1em; flex-wrap: wrap;">
                      <template v-for="tagId in message?.tags" :key="tagId">
                        <template v-if="tagsHashnew[tagId]">
                          <v-tooltip location="bottom" :text="tagsHashnew[tagId].tag_name">
                            <template v-slot:activator="{ props }">
                              <div v-bind="props" style="display: inline; margin: 0.1em;">
                                <v-btn size="18" color="white" elevation="3" icon>
                                  <v-icon size="15" :color="tagsHashnew[tagId].tag_color" @click="removeTag(tagId)">
                                    mdi-{{ tagsHashnew[tagId].tag_icon }}
                                  </v-icon>
                                </v-btn>
                              </div>
                            </template>
                          </v-tooltip>
                        </template>
                      </template>
                    </div>
            <div class="d-flex flex-column">
              <div class="message-note" v-if="!editingNote" @click.stop="startEditing">
                  <v-icon size="12">mdi-note-text</v-icon>
                  <span>{{ displayNote }}</span>
              </div>
           <!-- Editable version -->
            <div v-else class="message-note-edit">
                  <div
                    class="editable-note"
                    contenteditable="true"
                    ref="editable"
                    @input="onInput"
                    @focus="moveCursorToEnd"
                  ></div>

                <div class="note-actions">
                  <v-icon size="16" color="green" @click.stop="saveNote">mdi-check</v-icon>
                  <v-icon size="16" color="red" @click.stop="cancelNote">mdi-close</v-icon>
                </div>
            </div>
            <div v-if="message.tagRemovalNotes?.length" class="tag-removal-note">
              <div v-for="(note, i) in message.tagRemovalNotes" :key="i" class="d-flex align-center" style="gap: 4px">
                <v-icon size="12">mdi-tag-off-outline</v-icon>
                <span>{{ note.message }} ({{ simplifyDate(note.date, "MMM D, YYYY h:mm A") }})</span>
              </div>
            </div>
            </div>
                    <div class="time" style="flex-shrink: 0;">
                      <a
                        v-if="message?.src_language == 'es' && message.text_message_id != null"
                        class="translate" :ref="`translate_${message.text_message_id}`"
                        @click="translateMsg(message.text_message_id, message.originalMsg, message.message)"
                        target="_blank"
                      >
                        show original
                        <v-tooltip activator="parent" location="bottom">Translate</v-tooltip>
                      </a>
                      {{ simplifyDate(message?.date, "LT") }}
                    </div>
                  </div>
                
              </div> <!-- End icon-spacing -->

              <!-- Conversation Scroll-down arrow -->
              <div v-if="message.internal_convo_count" class="convo-arrow" @click="toggleInlineConvo">
                <v-icon size="12" style="margin-top: -5%;">mdi-arrow-right-bottom</v-icon>
                <span>view {{ message.internal_convo_count }} convo(s)</span>
                <v-tooltip activator="parent" location="bottom">View convo(s) on this item</v-tooltip>
              </div>
            </div> <!-- End chat-bubble -->
          </template>
        </v-menu>
      </template>

      <!-- System messages -->
      <template v-else>
        <div
          class="text-caption systemMessage"
          :class="{ 'systemMessage--clickable': message.ref_conversation_id }"
          @click="message.ref_conversation_id ? goToTaggedMessage() : null"
        >
          <v-icon v-if="message.ref_conversation_id" size="14" style="margin-right: 2px;">mdi-hand-pointing-up</v-icon>
          {{ message.message + " (" + simplifyDate(message?.date, "LT") + ")" }}
        </div>
      </template>
    </div> <!-- End chat-bubble-container -->

    <!-- Internal convo(s) referencing this message, shown inline instead of
         opening the right panel -->
    <div v-if="showInlineConvo" class="inline-convo-container">
      <!-- Picker, only when more than one convo references this message -->
      <div v-if="!selectedInlineConvo && inlineConvoList.length > 1">
        <div class="d-flex align-center justify-space-between mb-1">
          <span class="text-caption font-weight-medium">Select a conversation</span>
          <v-icon size="16" @click="closeInlineConvo">mdi-close</v-icon>
        </div>
        <v-list density="compact">
          <v-list-item
            v-for="c in inlineConvoList"
            :key="c.convo_id"
            @click="selectInlineConvo(c)"
          >
            <v-list-item-title>{{ c.convo_name }}</v-list-item-title>
            <v-list-item-subtitle v-if="c.messages_updated_at">{{ simplifyDate(c.messages_updated_at, "LLL") }}</v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </div>

      <!-- Thread, once a convo is selected (or skipped straight to when there's only one) -->
      <div v-else-if="selectedInlineConvo">
        <div class="d-flex align-center justify-space-between mb-1">
          <span class="text-caption font-weight-medium">{{ selectedInlineConvo.convo_name }}</span>
          <v-icon size="16" @click="closeInlineConvo">mdi-close</v-icon>
        </div>
        <div class="inline-convo-messages">
          <Message
            v-for="(m, idx) in inlineMessages"
            :key="m.convo_message_id"
            :message="m"
            :prev="idx === 0 ? null : inlineMessages[idx - 1]"
            :index="idx"
            :active="true"
            :refrenceConvo="getInlineReferenceMessage(m.ref)"
            @reference-click="scrollToInlineReference"
          />
        </div>
        <ConvoBox :convo="selectedInlineConvo" />
      </div>
    </div>

    <!-- Spacing adjustment -->
    <div v-if="message?.internal_convo_count" style="font-size: 0.8rem"><br/></div>
    <div v-else style="font-size: 0.2rem"><br /></div>

    <DocumentExtractionDialog
      v-model="extractionDialogOpen"
      :media-id="extractionMediaId"
      :contact-id="contact?.contact_id"
    />

    <!-- Resolve a due reminder tied to this message before letting its
         "Unattended" tag be untagged (see removeTag) -->
    <v-dialog v-model="dueReminderDialog" max-width="360px">
      <v-card>
        <v-card-title class="text-subtitle-1">Reminder Due</v-card-title>
        <v-card-text v-if="!selectedDueReminder && dueReminders.length > 1">
          <v-list density="compact">
            <v-list-item
              v-for="r in dueReminders"
              :key="r.convo_reminder_id"
              @click="selectedDueReminder = r"
            >
              <v-list-item-title>{{ reminderPickerLabel(r) }}</v-list-item-title>
              <v-list-item-subtitle>{{ reminderSetInfo(r) }} &middot; Due {{ simplifyDate(r.reminder_date, "LLL") }}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-text v-else-if="dueReminders.length">
          <div class="text-caption text-medium-emphasis mb-2">
            {{ reminderSetInfo(currentDueReminder) }} &middot;
            Due {{ simplifyDate(currentDueReminder.reminder_date, "LLL") }}
          </div>
          <QuickReminderMenu
            has-reminder
            :existing-date="currentDueReminder.reminder_date"
            @select="resolveReminderSelect"
            @remove="resolveReminderRemove"
          />
          <!-- Every set/reschedule of this reminder leaves a system message on
               its own convo (see addSystemMessage calls in updateReminder etc.)
               — that's already a full chronological log, just surface it. -->
          <div v-if="reminderHistory.length" class="text-caption text-medium-emphasis mt-3">
            <div class="font-weight-medium mb-1">History</div>
            <div v-for="(h, i) in reminderHistory" :key="i" class="mb-1">{{ h }}</div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import { mapActions } from "vuex";

import MiscService from "@/services/miscService";
import plivoApiService from "@/services/plivoService";
import EventBus from "@/eventBus";
import { phoneFormatTitle, getPhoneIcon } from "@/util/util";
import CustomPopup from "../CustomPopup.vue";
import TagService from "@/services/tagService";
import AudioPlayer from "../UIComponents/AudioPlayer.vue";
import ConvoService from "@/services/convoService";
import { ALERT } from "../../constants/alert.js"
import Email from "../../views/Email.vue";
import DocumentExtractionDialog from "./RightPanel/DocumentExtractionDialog.vue";
import QuickReminderMenu from "@/components/Messenger/QuickReminderMenu.vue";
import ConvoBox from "./RightPanel/ConvoBox.vue";
import Message from "@/components/Messenger/Message.vue";



export default {
 components: {
  Email
 },
  data: () => ({
    items: [{ title: "Re-Send" }, { title: "Delete" }],
    chatRefs: [],
    showCustomPopup : false,
    isTagPopup : false,
    showOptions : false,
    // "Unattended" tag-removal intercept (this message's due reminder(s),
    // fetched only when the user tries to remove that tag while one is due)
    dueReminderDialog: false,
    dueReminders: [],
    selectedDueReminder: null,
    reminderHistory: [],
    reminderHistoryConvoId: null,
    quickReminderMenuOpen: false,
    // Internal convo(s) referencing this message, shown inline instead of
    // opening the right panel (see toggleInlineConvo). inlineConvoList is a
    // computed (below), not stored here, so it stays live if a convo gets
    // auto-closed (e.g. a reminder-only convo whose reminder was removed)
    // while this section is open.
    showInlineConvo: false,
    selectedInlineConvo: null,
    inlineMessages: [],
    showEmailModal: false,
    show: true,
    // selectedEmail: false,
    modalVisible: false,
    editingNote: false,
    tempNote: "",
    oldNote: "",
    extractionDialogOpen: false,
    extractionMediaId: null,
  }),
  name: "FDMessage",
  props: {
    message: { type: Object, default: null },
    prev: { type: Object, default: null },
    index: { type: Number, default: null },
    active: { type: Boolean, default: true },
    contact: { type: Object, default: null },
    highlight: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
  },
  components:{
    CustomPopup,
    AudioPlayer,
    DocumentExtractionDialog,
    QuickReminderMenu,
    ConvoBox,
    Message
  },
  computed: {
    ...mapGetters(["userId"]),
    ...mapGetters("convos", ["internal_convos_on_comm"]),
    ...mapGetters("people", ["getUserNames"]),
    ...mapGetters('tags',["tags","tagsHashnew","can_manual_tagging"]),
    ...mapGetters("frontdesk",["isUser"]),
    ...mapGetters("window", ["isMobile"]),
    displayDateHeader: function () {
      if (this.index == 0 || this.prev == null) return true;

      return (
        this.simplifyDate(this.message.date, "LL") !=
        this.simplifyDate(this.prev.date, "LL")
      );
    },
    translateRef() {
      return "translate_" + this.message.text_message_id;
    },
    filteredTags(){
      // Displaying only Un-Selected tags. Ignore selected tags and unlisted tags.
      const unselected = this.tags.filter(
        (tag) => !this.message.tags.includes(tag.tag_id) && !tag.unlist
      );
      return unselected;
    },
 displayNote() {
   const note =this.message?.message_note ?? null;
  return !note || note === "null" ? "Add note..." : note;
},
    unattendedTagId() {
      const tag = this.tags.find(t => t.tag_name === "Unattended");
      return tag ? tag.tag_id : null;
    },
    // the reminder the dialog is actually acting on — either the one the user
    // picked from the multi-reminder list, or the sole due reminder when
    // there's only one (removeTag skips the list in that case)
    currentDueReminder() {
      if (this.selectedDueReminder) return this.selectedDueReminder;
      return this.dueReminders.length === 1 ? this.dueReminders[0] : null;
    },
    // Live-reactive to state.internal_convos, unlike a plain data snapshot —
    // so if the currently-open one gets auto-closed elsewhere (e.g. its
    // reminder-only convo's reminder was just removed), this list updates on
    // its own instead of continuing to show a now-closed convo.
    inlineConvoList() {
      if (!this.showInlineConvo) return [];
      return this.internal_convos_on_comm(this.message.comm_participant_id) || [];
    },
  },
  watch: {
    currentDueReminder(r) {
      if (r) this.loadReminderHistory(r.convo_id);
      else {
        this.reminderHistory = [];
        this.reminderHistoryConvoId = null;
      }
    },
    inlineConvoList(newList) {
      if (!this.selectedInlineConvo) return;
      if (newList.some(c => c.convo_id === this.selectedInlineConvo.convo_id)) return;

      // the convo we had open just closed (or was otherwise removed) — fall
      // back instead of showing a stale/empty thread. Handle all three cases:
      // none left (collapse), exactly one left (skip straight to it, same as
      // toggleInlineConvo's own single-convo shortcut), or several left (drop
      // back to the picker list).
      if (!newList.length) {
        this.closeInlineConvo();
      } else if (newList.length === 1) {
        this.selectInlineConvo(newList[0]);
      } else {
        this.selectedInlineConvo = null;
        this.inlineMessages = [];
      }
    },
  },
  methods: {
    ...mapMutations(['changeRightPanelStatus']),
   ...mapMutations("frontdesk",["toggleThreadVisibility", "thread"]),
   ...mapActions("frontdesk", ["retrieveEmails", "searchConversation"]),
   ...mapActions("convos", ["getInternalMessages"]),
    phoneFormatTitle,
    getPhoneIcon,
    async goToTaggedMessage() {
      if (!this.message.ref_conversation_id) return;
      await this.searchConversation({ timestamp: this.message.ref_timestamp, contact_id: this.contact.contact_id });
      this.$nextTick(() => {
        EventBus.$emit("scroll-to-reference", { id: this.message.ref_conversation_id, highlight: true });
      });
    },
    setChatRefs(el) {
        if (el) {
          this.chatRefs.push(el);
        }
      },
    calculateNudge() {
      return (this.message.comm_direction === 'inbound' || this.message.comm_direction === 'incoming' || this.message.comm_direction==='received' ? -10 : 10);
    },
    isInbound() {
      return (this.message.comm_direction === 'inbound' || this.message.comm_direction === 'incoming'|| this.message.comm_direction==='received');
    },
    createInternalConvo() {
      this.showOptions = false;
      this.changeRightPanelStatus(true);
      setTimeout(()=>{
        EventBus.$emit("convoRef",this.chatRefs)
        EventBus.$emit("createConvo", this.message);
      },0)
    },
    // Internal convo(s) referencing this message, shown inline directly
    // under it instead of opening the right panel's "internalConversations"
    // tab. internal_convos_on_comm/getInternalMessages are shared Vuex
    // getters/actions (moduleConvos.js) — RightPanel.vue's own thread view
    // uses the exact same ones, so a new message sent here or there (or
    // arriving live over the websocket) stays in sync everywhere for free.
    toggleInlineConvo() {
      if (this.showInlineConvo) {
        this.closeInlineConvo();
        return;
      }
      this.showInlineConvo = true;
      if (this.inlineConvoList.length === 1) {
        this.selectInlineConvo(this.inlineConvoList[0]);
      }
    },
    async selectInlineConvo(convo) {
      this.selectedInlineConvo = convo;
      this.inlineMessages = await this.getInternalMessages(convo.convo_id);
    },
    closeInlineConvo() {
      this.showInlineConvo = false;
      this.selectedInlineConvo = null;
      this.inlineMessages = [];
    },
    getInlineReferenceMessage(ref) {
      if (ref === null || ref === undefined) return null;
      const referenceMessage = this.inlineMessages.find((m, idx) => {
        if (m.convo_message_id === ref) {
          m.index = idx;
          return true;
        }
        return false;
      });
      return referenceMessage ? { ...referenceMessage } : null;
    },
    scrollToInlineReference(refIndex) {
      const element = document.getElementById(`message-${refIndex}`);
      if (element) {
        element.style.backgroundColor = 'yellow';
        setTimeout(() => { element.style.backgroundColor = ''; }, 2000);
      }
    },
    //Get the call recording file URL
    openImg: function (src) {
     console.log("src = ",src);
      window.open(src, "_blank");
    },
    openExtractionDialog(mediaItem) {
      this.extractionMediaId = mediaItem.media_id;
      this.extractionDialogOpen = true;
    },
    alert: function (msg) {
      window.alert(msg);
    },
    recording: function (callUUID) {
      return MiscService.getCallRecordingURL(callUUID);
    },
    resendMessage(textMsgId) {
      console.log("clicked resend!" + textMsgId);
      return plivoApiService.resendMessage(textMsgId);
    },
    translateMsg(textMsgId, textMessage, translatedMsg) {
      let textInSpan = this.$refs["text_message_" + textMsgId].textContent;
      console.log("The text inside is :" + textInSpan);
      console.log(
        "The anchor text inside is :" +
          this.$refs["translate_" + textMsgId].textContent
      );
      if (textInSpan === textMessage) {
        this.$refs["text_message_" + textMsgId].textContent = translatedMsg;
        this.$refs["translate_" + textMsgId].textContent = "show original";
      } else {
        this.$refs["text_message_" + textMsgId].textContent = textMessage;
        this.$refs["translate_" + textMsgId].textContent = "show translated";
      }
      console.log(
        "we need to translate ," +
          textMsgId +
          " with orig msg as :" +
          textMessage +
          " translated msg as " +
          translatedMsg +
          " with action :" +
          JSON.stringify(this.$refs)
      );
      //MiscService.getText(true,textMsgId);
    },
    //Get the call Multimedia file URL
    getFileUrl: function (message,value) {
     let msgId=message.email_id?message.email_id:message.text_message_id;
      let mediaId=value.media_id;
     //for mail case
     // Absolute URL, not a relative "/api/..." path: in local dev the
     // frontend (vue-cli-service, :8081) and backend (:3000) are separate
     // origins with no devServer proxy configured, so a relative path
     // would resolve against the frontend dev server, which has no such
     // route. Only works as a relative path in production, where the
     // backend itself serves the built frontend from the same origin.
     if(message.email_id){
             return process.env.VUE_APP_API_URL + '/api/messages/email/' + msgId+ '/media/' + mediaId;
      //return MiscService.getEmailMedia(msgId,mediaId);
     }else{
          return process.env.VUE_APP_API_URL + '/api/messages/text_message/' + msgId + '/media/' + mediaId;
      //return MiscService.getMultimediaUrl(msgId, mediaId);
      }
    },
    // the possible formats can be found at dayjs.com
    simplifyDate(date, format) {
      return this.dayjs.utc(date).format(format);
    },
    // returns true if the two dates are within n minutes
    withinMinutes(date1, date2, n) {
      return this.dayjs(date1).diff(this.dayjs(date2), "minute") <= n;
    },
    // splits the message by mentions
    splitbyMentions(message) {
      let splitIndices = [];
      message.convo_mentions.forEach((m) => {
        splitIndices.push(m.index_start);
        splitIndices.push(m.index_end);
      });
      let acc = -1;
      return [0, ...splitIndices].map((n, i, m) => {
        return {
          text: message.message.slice(n, m[i + 1]),
          user_id:
            i % 2 !== 0 ? message.convo_mentions[(acc += 1)].user_id : null,
          index: i,
          completed: i % 2 !== 0 ? message.convo_mentions[acc].completed : null,
        };
      });
    },
    // opneEmailPopup(email){
    //   this.selectedEmail = true;
    //   this.modalVisible = true;
    // }
    openModal(threadId) {
     
      this.retrieveEmails(threadId);
      this.toggleThreadVisibility();
    },
    openTagPopup(){
      this.showOptions = false;
      this.isTagPopup = true;
      this.showCustomPopup = !this.showCustomPopup;
    },
    async applyTag(tagId){
      let res;
      this.showCustomPopup = false;
      try {
        let payload = {conversation_id : this.message.comm_participant_id, tag_id : tagId};
        res = await TagService.addConversationTag(payload);
        if(res.status == 201){
          this.message.tags.push(tagId); 
          EventBus.$emit("alert", {
           message: "Tag Added Successfully",
           type: ALERT.SUCCESS,
         });
        }
      } catch (error) {
        EventBus.$emit("alert", {
           message: "Failed To Add Tag",
           type: ALERT.ERROR,
         });
        console.error(error);
        
      }
    },
    async removeTag(tagId){
      // Removing "Unattended" while a reminder tied to this exact message is
      // still due shouldn't just untag it — offer to reschedule/remove the
      // reminder itself first (the tag only actually clears server-side once
      // every due reminder on this conversation_id is resolved, see
      // clearReminderIndicatorsIfNoneRemain in convo.controller.js).
      if (tagId === this.unattendedTagId) {
        try {
          const res = await ConvoService.getDueRemindersForConversation(this.message.comm_participant_id);
          const due = res?.data?.data || [];
          if (due.length) {
            this.dueReminders = due;
            this.selectedDueReminder = due.length === 1 ? due[0] : null;
            this.dueReminderDialog = true;
            return;
          }
        } catch (error) {
          console.error(error);
        }
      }
      await this._removeTagDirect(tagId);
    },
    async _removeTagDirect(tagId){
      let res;
      try {
        res = await TagService.removeConversationTag(this.message.comm_participant_id, tagId);
        if(res.status == 200){
          // Mutate in place (matching applyTag's push) instead of
          // reassigning — renderConversations (FDMessenger.vue) shallow-
          // clones messages once any tag-removal system message exists in
          // the conversation, so the `tags` array reference must survive
          // that clone or this edit gets silently discarded on next render.
          const idx = this.message.tags.indexOf(tagId);
          if (idx !== -1) this.message.tags.splice(idx, 1);
          EventBus.$emit("alert", {
           message: "Tag Removed Successfully",
           type: ALERT.SUCCESS,
         });
        }
      } catch (error) {
        EventBus.$emit("alert", {
           message: "Failed To Remove Tag",
           type: ALERT.ERROR,
         });
        console.error(error);
      }
    },
    // who set / who the reminder is for, e.g. "Jane (for John)" when someone
    // else is resolving a reminder they didn't set — or just "Jane" when
    // who_set === reminder_for_who.
    reminderPickerLabel(r) {
      const forWho = this.getUserNames([r.reminder_for_who]);
      if (r.who_set === r.reminder_for_who) return forWho;
      return `${forWho} (set by ${this.getUserNames([r.who_set])})`;
    },
    // "Set by <name> on <date>" — who actually set the reminder and when,
    // shown alongside the due date so it's clear at a glance in the resolve
    // dialog, not just who it's currently for.
    reminderSetInfo(r) {
      const setBy = this.getUserNames([r.who_set]);
      if (!r.date_set) return `Set by ${setBy}`;
      return `Set by ${setBy} on ${this.simplifyDate(r.date_set, "LLL")}`;
    },
    // Every set/reschedule/removal of a reminder already leaves a system
    // message on its own convo (see the addSystemMessage calls alongside
    // addReminder/updateReminder/deleteReminder etc. in convo.controller.js)
    // — that's a ready-made chronological log of every previous "set", just
    // needs surfacing here instead of building a separate history table.
    async loadReminderHistory(convo_id) {
      if (this.reminderHistoryConvoId === convo_id) return;
      this.reminderHistoryConvoId = convo_id;
      this.reminderHistory = [];
      try {
        const res = await ConvoService.getInternalConvoMessages(convo_id);
        const messages = res?.data || [];
        this.reminderHistory = messages
          .filter(m => m.who_sent === 0 && m.message && /reminder/i.test(m.message))
          .sort((a, b) => new Date(a.date) - new Date(b.date))
          .map(m => m.message);
      } catch (error) {
        console.error("Failed to load reminder history", error);
      }
    },
    closeDueReminderDialog() {
      this.dueReminderDialog = false;
      this.dueReminders = [];
      this.selectedDueReminder = null;
      this.reminderHistory = [];
      this.reminderHistoryConvoId = null;
    },
    async resolveReminderSelect(dateIso) {
      const target = this.selectedDueReminder || this.dueReminders[0];
      try {
        await ConvoService.updateInternalReminder({
          convo_id: target.convo_id,
          date: dateIso,
          convo_reminder_id: target.convo_reminder_id,
        });
        EventBus.$emit("alert", { message: "Reminder Updated Successfully", type: ALERT.SUCCESS });
      } catch (error) {
        console.error(error);
        EventBus.$emit("alert", { message: "Failed To Update Reminder", type: ALERT.ERROR });
      }
      this.closeDueReminderDialog();
    },
    async resolveReminderRemove() {
      const target = this.selectedDueReminder || this.dueReminders[0];
      try {
        await ConvoService.deleteInternalConvoReminder(target.convo_id, target.convo_reminder_id);
        EventBus.$emit("alert", { message: "Reminder Removed Successfully", type: ALERT.SUCCESS });
      } catch (error) {
        console.error(error);
        EventBus.$emit("alert", { message: "Failed To Remove Reminder", type: ALERT.ERROR });
      }
      this.closeDueReminderDialog();
    },
    // dateIso is emitted directly by QuickReminderMenu (preset or custom) —
    // creates a new internal convo bridged to this exact message
    // (convo_references.conversation_id) and sets the reminder on it, same
    // as the old fixed 3-icon quick-reminder did.
    async applyQuickReminder(dateIso){
      this.quickReminderMenuOpen = false;
      try {
        let payload = {
          "message": `Reminder for ${this.dayjs(dateIso).format("MMM D, YYYY h:mm A")}`,
          "contact_id": this.contact.contact_id,
          "conversation_id":this.message.comm_participant_id,
          "type":'internal',
          "reminder_only": true
        }
        let res = await ConvoService.createInternalConvo(payload);
        if(res.data.convo_id){
          let payload2 = {"date": dateIso, "convo_id": res.data.convo_id};
          let res2 = await ConvoService.addInternalReminder(payload2);
          if(res2.status == 200){
              EventBus.$emit("alert", {
               message: "Reminder Added Successfully",
               type: ALERT.SUCCESS,
            });
          }
          EventBus.$emit("update-InternalConvos",(this.contact.contact_id));
        }
      } catch (error) {
        console.log(error);
        EventBus.$emit("alert", {
          message: "Failed To Add Reminder",
          type: ALERT.ERROR,
        });
      }
    },
    onTouchStart(){
        setTimeout(()=>{ this.showOptions = true},600)
    },
    onTouchEnd() {
        // Don't yank the quick-reminder dropdown away while it's open — it lives
        // inside this same showOptions-gated row (see closeoptions below).
        setTimeout(()=>{ if (!this.quickReminderMenuOpen) this.showOptions = false},3000)
    },
    closeoptions(){
      if(this.isMobile) return;
      // The quick-reminder v-menu's content is teleported outside this row's DOM
      // subtree, so moving the mouse onto it (e.g. to use the Custom date field)
      // fires this mouseleave handler — re-check at fire time so an open menu
      // isn't unmounted mid-interaction.
      setTimeout(()=>{ if (!this.quickReminderMenuOpen) this.showOptions=false},500)
    },
   startEditing() {
      const current =this.message?.message_note ?? this.message?._raw?.message_note ?? "";
      this.oldNote = current;
      this.tempNote = current === "null" ? "" : current || "";
      this.editingNote = true;
      this.$nextTick(() => {
            const el = this.$refs.editable;
            if (el) {
              el.innerText = this.tempNote;
              this.moveCursorToEnd();
            }
          });
    },
    onInput(e) {
      this.tempNote = e.target.innerText;
    },
    moveCursorToEnd() {
      const el = this.$refs.editable;
      if (!el) return;
      const range = document.createRange();
      const sel = window.getSelection();
      range.selectNodeContents(el);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
    },
 async saveNote() {
  try {
    const noteText = this.tempNote.trim();

    if (!noteText) {
      EventBus.$emit("alert", {
        message: "Note cannot be empty!",
        type: ALERT.ERROR,
      });
      return;
    }

    let conversation_id = this.message?.comm_participant_id;
    let payload = {
      message_note: noteText,
    };
    if(this.message.text_message_id){
      payload.id = this.message.text_message_id;
      payload.type = "text_message";
    }else if(this.message.call_id){
      payload.id = this.message.call_id;
      payload.type = "call";
    }else if(this.message.email_id){
      payload.id = this.message.email_id;
      payload.type = "email";
    }

    await MiscService.addConversationNotes(conversation_id, payload);

    if (this.message) {
      this.message.message_note = noteText;
    }
  } catch (err) {
    console.error("error", err);
    if (this.message) {
      this.message.message_note = this.oldNote;
    }
  }
  this.editingNote = false;
},
cancelNote() {
  if (!this.message) return;
  this.message.message_note = this.oldNote;
  this.editingNote = false;
},
  }
};
</script>

<style scoped>
.chat-bubble-container {
  white-space: pre-wrap;
  display: flex;
}

.chat-bubble {
  text-align: left;
  font-size: 0.9rem;
  width: auto;
  max-width: 60%;
  padding: 0.4rem 0.5rem;
  border-radius: 0.5rem;
}

.inbound {
  background-color: #e3e3e3;
  margin-left: 0.3rem;
  margin-right: auto;
}

.outbound {
  background-color: #d9f7dc;
  align-items: flex-end;
  align-content: flex-end;
  align-self: flex-end;
  margin-right: 0.3rem;
  margin-left: auto;
}

.other-call {
  align-items: center;
  align-content: center;
  align-self: center;
  margin-right: 0.3rem;
  margin-left: auto;
}

.message-incoming {
  margin-left: 0.3rem;
}

/* .email-incoming {
  margin-left: 0.3rem;
} */

.systemMessage {
  flex: 1;
  color: #6e6e6e;
}

.systemMessage--clickable {
  cursor: pointer;
}

.systemMessage--clickable:hover {
  text-decoration: underline;
}

.separator {
  display: flex;
  align-items: center;
}

.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
}

.date {
  border: 1px solid #e0e0e0;
  border-radius: 0.5rem;
  padding: 0.1rem 0.5rem;
}

.time {
  font-size: 0.6rem;
  text-align: right;
  color: #90a09f;
  flex-shrink: 0;
}

.user {
  font-size: 0.6rem;
  text-align: right;
  color: #90a09f;
  margin-left: 0.5rem;
}

.contact {
  font-size: 0.6rem;
  text-align: left;
  color: #90a09f;
}

.video-element {
  height: 150px;
  max-height: 150px;
  max-width: 250px;
}

.icon-spacing i {
  margin-left: 5px;
  margin-right: 5px;
}

.quote {
 display: inline-block;
 background-image: url(https://www.gstatic.com/images/icons/material/system_gm/1x/more_horiz_black_20dp.png);
 background-position: center;
 background-repeat: no-repeat;
 background-size: 20px; 
 height: 11px; 
 width: 24px;
 opacity: .71;
 cursor: pointer;
 background-color: #f1f1f1;
 border: 1px solid #ddd;
 text-align: center;
 outline: none;
 position: relative;
 overflow: hidden;
}
.translate {
  cursor: pointer;
  color: blue;
}
.convo-arrow{
  position: absolute;
  margin-top: 0.8%;
  margin-left: -0.4%;
  cursor: pointer;
  transition: all 0.3s ease-in-out; 
  color: #8e918f;
  font-family: Google Sans Text, Google Sans, Roboto, Arial, sans-serif;
  line-height: 1rem;
  font-size: .65rem;
  letter-spacing: .00625rem;
  font-weight: 500;
  
}
.convo-arrow:hover {
  color: #000000;

  transform: scale(1.2);
}
.inline-convo-container {
  border: 2px solid #0066ff;
  border-radius: 8px;
  background: #fff9c4;
  color: #0066ff;
  padding: 8px;
  margin: 4px 0 10px;
}
.inline-convo-messages {
  max-height: 260px;
  overflow-y: auto;
  margin-bottom: 6px;
}
.message-note-box {
  margin-top: 4px;
  margin-left: 0.6rem;
}

.message-note {
  font-size: 0.7rem;
  color: #6c757d;
  background: #f6f6f6;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.tag-removal-note {
  font-size: 0.7rem;
  color: #6c757d;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 2px;
}

.message-note:hover {
  background: #eaeaea;
}

.message-note-edit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  padding: 2px 6px;
}

.editable-note {
  flex: 1;
  min-width: 80px;
  font-size: 0.7rem;
  color: #333;
  outline: none;
  border: none;
  background: transparent;
}

.note-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.note-actions .v-icon {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.note-actions .v-icon:hover {
  transform: scale(1.1);
}
</style>
